<template>
  <div>
    <b-card>
      <modals-container v-model="items" />

      <template>
        <mdb-container>
          <mdb-modal
            :show="confirmar"
            @close="confirmar = false"
            size="sm"
            class="text-center"
            style="top:40px;"
            danger
          >
            <mdb-modal-header center :close="false">
              <p class="heading">Confirmar que quieres eliminar la linea {{nameLine}}</p>
            </mdb-modal-header>
            <mdb-modal-body>
              <mdb-icon icon="times" size="4x" class="animated rotateIn" />
            </mdb-modal-body>
            <mdb-modal-footer center>
              <mdb-btn outline="danger" @click="eliminar()">Si</mdb-btn>
              <mdb-btn color="danger" @click="confirmar = false">No</mdb-btn>
            </mdb-modal-footer>
          </mdb-modal>
        </mdb-container>
      </template>

      <template>
        <div>
          <mdb-modal fullHeight info :show="modal" @close="modal = false">
            <mdb-modal-header>
              <mdb-modal-title>{{modalName}} línea de Contenido</mdb-modal-title>
            </mdb-modal-header>
            <form novalidate @submit.prevent="crearLine">
              <mdb-modal-body>
                <mdb-input
                  placeholder="Nombre"
                  class="mb-3 mt-0"
                  v-model="nameLine"
                  required
                  invalidFeedback="Coloca el nombre"
                >
                  <span class="input-group-text md-addon" slot="prepend">Nombre</span>
                </mdb-input>

                <mdb-input
                  placeholder="Descripción"
                  class="mb-3 mt-0"
                  v-model="descriptionLine"
                  required
                  invalidFeedback="Descripción"
                >
                  <span class="input-group-text md-addon" slot="prepend">Desripción</span>
                </mdb-input>
              </mdb-modal-body>
              <mdb-modal-footer>
                <mdb-btn color="secondary" @click.native="modal = false">Cerrar</mdb-btn>
                <mdb-btn type="submit" color="primary" :disabled="isLoadingLine">
                  <span v-if="!isLoadingLine && modalName=='Crear'">Crear</span>
                  <span v-if="!isLoadingLine && modalName=='Editar'">Editar</span>
                  <semipolar-spinner
                    :animation-duration="2000"
                    :size="30"
                    color="#ffffff"
                    v-if="isLoadingLine"
                  ></semipolar-spinner>
                </mdb-btn>
              </mdb-modal-footer>
            </form>
          </mdb-modal>
        </div>
      </template>

      <b-btn variant="primary" class="p-2 mb-4" @click="openModal('Crear')">
        <i class="far fa-edit mr-1"></i>
        Nueva Línea de contenido
      </b-btn>
      <div slot="header" v-html="caption"></div>
      <b-table
        :dark="dark"
        :hover="hover"
        :striped="striped"
        :bordered="bordered"
        :small="small"
        :fixed="fixed"
        responsive="sm"
        :items="items"
        :fields="captions"
        :current-page="currentPage"
        :per-page="perPage"
      >
        <template slot="acciones" slot-scope="data">
          <b-row>
            <div class="seleccionar col-3">
              <b-badge variant="primary" class="p-2" @click="selectLineEdit(data.item,items)">
                <i class="far fa-edit mr-1"></i>Editar
              </b-badge>
            </div>
            <div class="seleccionar col-2">
              <b-badge variant="danger" class="p-2" @click="selectLineDelete(data.item)">
                <i class="far fa-trash-alt mr-1"></i>Eliminar
              </b-badge>
            </div>
          </b-row>
        </template>

        <!--<template slot="status" slot-scope="data">
          <b-badge :variant="getBadge(data.item.status)">{{data.item.status}}</b-badge>
        </template>-->
      </b-table>
      <nav>
        <b-pagination
          :total-rows="totalRows"
          :per-page="perPage"
          v-model="currentPage"
          prev-text="Prev"
          next-text="Next"
          hide-goto-end-buttons
        />
      </nav>
    </b-card>
  </div>
</template>

<script>
import store from "../../store";
import { SemipolarSpinner } from "epic-spinners";
import {
  mdbContainer,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalFooter,
  mdbRow,
  mdbBtn,
  mdbIcon,
  mdbTextarea,
  mdbInput
} from "mdbvue";
export default {
  name: "table-partners",
  inheritAttrs: false,
  components: {
    mdbContainer,
    SemipolarSpinner,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbModalFooter,
    mdbRow,
    mdbBtn,
    mdbIcon,
    mdbTextarea,
    mdbInput
  },
  props: {
    caption: {
      type: String,
      default: "Table"
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: [Array, Function],
      default: () => []
    },
    fields: {
      type: [Array, Object],
      default: () => []
    },
    perPage: {
      type: Number,
      default: 5
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      currentPage: 1,
      modalCreate: false,
      modal: false,
      isLoadingLine: false,
      id: "",
      nameLine: "",
      descriptionLine: "",
      modalName: "",
      confirmar: false
    };
  },
  computed: {
    items: function() {
      const items = this.tableData;
      return Array.isArray(items) ? items : items();
    },
    totalRows: function() {
      return this.getRowCount();
    },
    captions: function() {
      return this.fields;
    }
  },
  methods: {
    getBadge(status) {
      return status === "Active"
        ? "success"
        : status === "Inactive"
        ? "secondary"
        : status === "Pending"
        ? "warning"
        : status === "Banned"
        ? "danger"
        : "primary";
    },
    getRowCount: function() {
      return this.items.length;
    },
    isTrueSelect(acciones) {
      if (acciones) {
        return true;
      }
      return false;
    },
    openModal(etapa) {
      if (etapa == "Crear") {
        this.nameLine = "";
        this.descriptionLine = "";
      }
      this.modalName = etapa;
      this.modal = true;
    },
    crearLine(event) {
      event.target.classList.add("was-validated");
      var { nameLine, descriptionLine } = this;
      this.isLoadingLine = true;
      if (nameLine == "" || descriptionLine == "") {
        this.isLoadingLine = false;
      } else {
        var line = {};
        if (this.modalName == "Crear") {
          line = {
            nameLine,
            descriptionLine
          };
          store.dispatch("newLine", line).then(() => {
            this.nameLine = "";
            this.descriptionLine = "";
            this.isLoadingLine = false;
            this.modal = false;
          });
        } else {
          line = {
            id: this.id,
            nameLine,
            descriptionLine
          };
          store.dispatch("editLine", line).then(() => {
            this.nameLine = "";
            this.descriptionLine = "";
            this.id = "";
            this.isLoadingLine = false;
            this.modal = false;
          });
        }
      }
    },
    selectLineEdit(item, items) {
      this.nameLine = item.name;
      this.descriptionLine = item.description;
      this.id = item.id;
      this.openModal("Editar");
    },
    selectLineDelete(item) {
      this.id = item.id;
      this.nameLine = item.name;
      this.descriptionLine = item.description;
      this.modalName = "Eliminar";
      this.confirmar = true;
    },
    eliminar() {
      setTimeout(() => {
        store.dispatch("deleteLineUtility", this.id);
      }, 400);
      store.dispatch("deleteLine", this.id);
      this.confirmar = false;
    }
  }
};
</script>

<style scoped>
.badge {
  cursor: pointer;
}
.modal-body {
  overflow-y: auto;
  height: 400px;
  padding-top: 100px !important;
}
</style>
